import type React from "react"

// Typed identity function for a record of React.CSSProperties. Mirrors the
// shape of `componentStyles` from @mallardbay/lib-react-components, but for
// plain CSS styles applied to elements that do NOT resolve Chakra theme
// tokens (e.g. framer-motion's `motion.div`, plain `<div>`, or any other
// raw DOM element receiving a `style` prop).
//
// Prefer `componentStyles` whenever the consumer is a Chakra component and
// theme tokens are useful — reach for this only when the consumer is a
// non-Chakra primitive.
export function componentStylesCss<
    T extends Record<string, React.CSSProperties>,
>(styles: T): T {
    return styles
}
